// extracted by mini-css-extract-plugin
module.exports = {"container":"Expired_container__13FmT","title":"Expired_title__R7G-J","description":"Expired_description__1h9c7"};